/**
 * ACCORDION menu
 */
var component_block_accordion = function(args) {

  // setup args
  var accordionElem = args.accordionElem,
    site = args.site;

  // validate
  if (!accordionElem) {
    //console.log('Invalid or not at this page');
    return;
  }


  //Hide currentPanel and show new panel.
  function showPanel(panel) {
    //Hide current one. First time it will be null.
    // var expandedPanel = accordionElem.querySelector(".active-item");
    // if (expandedPanel) {
    //   expandedPanel.classList.remove("active-item");
    // }
    if (panel.classList.contains("active-item")) {
      panel.classList.remove("active-item");
    } else {

      //Show new one
      panel.classList.add("active-item");
    }


    const panel_answer = panel.querySelector('.accordion-content');
    if (panel_answer.style.maxHeight) {
      panel_answer.style.maxHeight = null;
    } else {
      panel_answer.style.maxHeight = panel_answer.scrollHeight + "px";
    }
  }

  //when panel is clicked, handlePanelClick is called.
  function handlePanelClick(event) {
    showPanel(event.currentTarget);
  }

  var allPanelElems = accordionElem.querySelectorAll(".block-accordion__single");
  for (var i = 0, len = allPanelElems.length; i < len; i++) {
    allPanelElems[i].addEventListener("click", handlePanelClick);
  }
  //By Default Show first panel
  //showPanel(allPanelElems[0]);

};

/**
 * Accordions
 */
let allAccordionElems = document.querySelectorAll(".wp-block-acf-accordion");
for (let i = 0, len = allAccordionElems.length; i < len; i++) {
  component_block_accordion({
    accordionElem: allAccordionElems[i],
    site: document.querySelector('.js-page'),
  });
}
// component_block_accordion({
//   accordionElem: document.querySelector('.wp-block-acf-accordion'),
//   site: document.querySelector('.js-page'),
// });